import {
  LoginPartialEvents,
  DepositPartialEvents,
  PromotionsPartialEvents,
  RegistrationPartialEvents,
} from '../types/partialEvents';
export const RECENTLY_PLAYED_CATEGORY_ID = 'recentlyPlayed';
export const SEARCH_RESULT_CATEGORY_ID = 'searchResult';
export const SUBNAVIGATION_CAROUSEL_ID = 'subnavigation-carousel';

export const COMMON_PARTIAL_LOGIN_EVENTS = {
  NonInteractionEvent: '0',
  EventCategory: 'Account Management',
  EventAction: 'Login Interactions',
  ElementType: 'Componentised',
};
export const PARTIAL_LOGIN_EVENTS_MAP = {
  login_open: {
    EventLabel: 'Login Open',
  },
  login_unsuccessful: {
    EventLabel: 'Login Unsuccessful',
  },
  login_successful: {
    EventLabel: 'Login Successful',
  },
  login_forgot_details: {
    EventLabel: 'Forgot Details',
  },
  login_forgot_username: {
    EventLabel: 'Forgot Username',
  },
  login_forgot_password: {
    EventLabel: 'Forgot Password',
  },

  logout: {
    EventLabel: 'Logout Successful',
    LoginStatus: 'Not logged in',
  },
};
export const ACCOUNT_BALANCE_NEEDING_EVENTS = ['login_successful', 'logout'];

export const COMMON_PARTIAL_DEPOSIT_EVENTS = {
  EventCategory: 'Deposit Interactions',
  EventAction: 'Quick Deposit',
  ElementType: 'Quick',
};
export const PARTIAL_DEPOSIT_EVENTS_MAP = {
  quick_deposit_open: {
    EventLabel: 'Deposit Open',
    NonInteractionEvent: '1',
  },
  quick_deposit_start: {
    EventLabel: 'Deposit Start',
    NonInteractionEvent: '0',
  },
  quick_deposit_unsuccessful: {
    EventLabel: 'Deposit Unsuccessful',
    NonInteractionEvent: '0',
    IsExistingPaymentMethodFlag: 'Y',
  },
  quick_deposit_successful: {
    EventLabel: 'Deposit Successful',
    NonInteractionEvent: '0',
    IsExistingPaymentMethodFlag: 'Y',
  },
};

export const COMMON_PARTIAL_PROMOTIONS_EVENTS = {
  NonInteractionEvent: '0',
  EventCategory: 'Promotion Interactions',
};
export const PARTIAL_PROMOTIONS_EVENTS_MAP = {
  promo_click: {
    EventAction: 'Promotion Click',
  },
  promo_opt_in: {
    EventAction: 'Promotion Opt-In',
    EventIdFromUrl: null,
  },
  promo_opt_out: {
    EventAction: 'Promotion Cancelled',
  },
};

export const COMMON_PARTIAL_REGISTRATION_EVENTS = {
  NonInteractionEvent: '0',
  EventCategory: 'Account Management',
  EventAction: 'Registration',
  ElementType: 'CRF | Trafalgar',
};
export const PARTIAL_REGISTRATION_EVENTS_MAP = {
  registration_open: {
    EventLabel: 'Registration Open',
  },
  registration_pageview: {},
  registration_step_unsuccessful: {},
  registration_complete_unsuccessful: {
    EventLabel: 'Registration Unsuccessful',
  },
  registration_complete_successful: {
    EventLabel: 'Registration Successful',
  },
};

export const LOGIN_PARTIAL_EVENTS_MAP: LoginPartialEvents[] = Object.keys(
  PARTIAL_LOGIN_EVENTS_MAP
).map(e => e as LoginPartialEvents);
export const DEPOSIT_PARTIAL_EVENTS_MAP: DepositPartialEvents[] = Object.keys(
  PARTIAL_DEPOSIT_EVENTS_MAP
).map(e => e as DepositPartialEvents);
export const PROMOTIONS_PARTIAL_EVENTS_MAP: PromotionsPartialEvents[] = Object.keys(
  PARTIAL_PROMOTIONS_EVENTS_MAP
).map(e => e as PromotionsPartialEvents);
export const REGISTRATION_PARTIAL_EVENTS_MAP: RegistrationPartialEvents[] = Object.keys(
  PARTIAL_REGISTRATION_EVENTS_MAP
).map(e => e as RegistrationPartialEvents);

// Unity / MTT
export const UNITY_TOPICS = {
  LOGIN: 'pam.callback.login.happened',
  LOGOUT: 'pam.callback.logout.happened',
  UPDATE_BALANCE: 'pam.callback.update_balance.happened',
  UPDATE_USER_STATE: 'pam.user.state-changed',
};
